module.exports = __webpack_public_path__ + "static/media/ashmi.f20e8266.jpg";